import {Component, OnInit, Injector, ChangeDetectorRef, Input, Output, EventEmitter} from '@angular/core';
import {PublicHttpService} from 'src/app/routes/teacher/public-http.service';
import {ShrAssemblyParams} from './shrAssemblyParams';
import * as publicMethods from '@shared/utils/publicMethods';
import {RespCodeEntityUtil} from 'src/app/routes/teacher/entity/respCodeEntityUtil';
import {PublicParams} from '@shared/utils/publicParams';
import {NormalCode} from '@shared/utils/normalCode';

@Component({
  selector: 'app-shr-assembly',
  templateUrl: './shr-assembly.component.html',
  styles: [],
})
export class ShrAssemblyComponent extends PublicHttpService implements OnInit {
  // 参数信息
  @Input() public initParams: ShrAssemblyParams;
  // 确定按钮触发器
  @Output() private supSave = new EventEmitter<string>();

  // 提交流程时的参数。注意：当前组件弹框前先设置此参数
  public submitParams: any = {};

  /**
   * 当前组件参数
   */
  public params: any = {
    ywlxid: '',
    norder: 0,
    gh: '',
    name: '',
    visible: false,
    loading: false,
    total: 0,
    page: 1,
    rows: 10,
  };

  // 列表数据
  datas: Array<RespCodeEntityUtil> = [];
  // 单选时选中的数据id
  public openid = '';
  // 多选时选择的数据id集合
  public openids: Array<string> = [];

  constructor(protected injector: Injector, public cdr: ChangeDetectorRef) {
    super(injector);
  }

  /**
   * 发起流程
   */
  saveModel(): void {
    if (!this.openid && this.openids.length <= 0) {
      this.message.create('warning', '请选择审核人！');
      return;
    }
    const par = publicMethods.generateFormData(this.submitParams);
    if (this.initParams.isSingle) {
      if (par.get('shstatus')) {
        par.append('nextShrid', this.openid);
      } else {
        par.append('shrid', this.openid);
      }
    } else {
      par.append('shrid', this.openids.join(PublicParams.string_split_str));
    }
    this.params.loading = true;
    this.http.post(this.initParams.submitUrl, par).subscribe((res: any) => {
      this.params.loading = false;
      if (res.err_code === NormalCode.NORMAL_CODE) {
        this.message.create('success', res.err_msg);
        this.params.visible = false;
        this.supSave.emit('发起流程成功！');
      } else {
        this.message.create('error', res.err_msg);
      }
    });
  }


  /**
   * 取消发起流程
   */
  cancelModel(): void {
    this.params.visible = false;
    this.openid = '';
    this.openids = [];
    this.params.gh = '';
    this.params.name = '';
    this.params.ywlxid = '',
      this.params.norder = 0,
      this.params.total = 0;
    this.params.page = 1;
    this.params.rows = 10;
  }

  /**
   * 列表点击事件
   */
  tableClick(data: any): void {
    if (this.initParams.isSingle) {
      publicMethods.radioLine(data, this.datas, [this.openid]);
      this.openid = data.openid;
    } else {
      publicMethods.multipleLines(data, this.openids);
    }
  }

  /**
   * 分页查询列表
   */
  findPage(): void {
    const par = publicMethods.generateFormData({
      ywlxid: this.params.ywlxid,
      norder: this.params.norder,
      gh: this.params.gh,
      name: this.params.name,
      page: this.params.page,
      rows: this.params.rows,
    });
    this.params.loading = true;
    this.http.post(this.initParams.url, par).subscribe((res: any) => {
      this.params.loading = false;
      if (res.err_msg) {
        this.message.create('error', res.err_msg);
        return;
      }
      if ((this.params.page - 1) * this.params.rows > res.total) {
        this.params.page = 1;
        this.findPage();
      }
      this.datas = [];
      if (res.rows) {
        res.rows.forEach((element: RespCodeEntityUtil) => {
          this.datas.push(element);
        });
        // 默认选中第一条
        this.tableClick(this.datas[0]);
        this.params.visible = true;
      } else {
        this.message.create('warning', "该流程尚未创建流程节点，请联系管理员!");
      }
      this.params.total = res.total;
    });
  }

  ngOnInit() {
  }
}
